export default __webpack_public_path__ + "static/media/ia_logo.bfc22230.png";